import script from "./project.vue?vue&type=script&setup=true&lang=js"
export * from "./project.vue?vue&type=script&setup=true&lang=js"

import "./project.vue?vue&type=style&index=0&id=7fb8533f&lang=less"

const __exports__ = script;

export default __exports__